var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.282 9.656a1.5 1.5 0 0 1 .139.633c0 .809-.636 1.466-1.421 1.466-.784 0-1.421-.657-1.421-1.466 0-.81.637-1.467 1.42-1.467.22 0 .428.051.614.143l2.24-2.31c.445-.462 1.116.23.67.69l-2.24 2.311Zm-.947.287A.462.462 0 0 0 10 9.8a.482.482 0 0 0-.473.489c0 .269.212.488.473.488.262 0 .474-.219.474-.488a.498.498 0 0 0-.138-.346h-.001ZM3.369 9.8c.632 0 .632.977 0 .977H1.961a8.42 8.42 0 0 0 2.02 5.032l.997-1.026c.446-.461 1.116.23.67.69l-1.342 1.384a.464.464 0 0 1-.67 0c-3.515-3.628-3.515-9.509 0-13.136 3.516-3.628 9.213-3.628 12.728 0 3.515 3.627 3.515 9.508 0 13.136a.464.464 0 0 1-.67 0l-1.34-1.383c-.446-.461.224-1.152.67-.691l.996 1.026a8.423 8.423 0 0 0 2.02-5.032h-1.408c-.632 0-.632-.977 0-.977h1.407a8.423 8.423 0 0 0-2.02-5.032l-.994 1.027c-.447.461-1.116-.23-.67-.69l.995-1.028a7.885 7.885 0 0 0-4.876-2.085v1.452c0 .653-.947.653-.947 0V1.992A7.885 7.885 0 0 0 4.65 4.077l.996 1.027c.446.461-.224 1.152-.67.691L3.98 4.768A8.423 8.423 0 0 0 1.961 9.8H3.37Z",
    fill: "currentColor",
    fillRule: "nonzero",
    stroke: "currentColor",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavDashboard);
export default __webpack_public_path__ + "static/media/nav-dashboard.2e0d8df0b1d849909ac717208ae6074f.svg";
export { ForwardRef as ReactComponent };